module.exports = __webpack_public_path__ + "img/processing.5052b1a9.png";